import { auth, db } from '@/firebase.js'
import firebase from 'firebase/app'

const userAccess = {
  state: {
    currentUser: null, // { email, displayName, photoURL, uid }
    userRole: null, // 'admin' | 'user' | null
    authInitialized: false
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user
    },
    setUserRole(state, role) {
      state.userRole = role
    },
    setAuthInitialized(state, status) {
      state.authInitialized = status
    }
  },
  actions: {
    initAuth({ commit, dispatch }) {
      return new Promise((resolve) => {
        auth.onAuthStateChanged(async (user) => {
          if (user) {
            commit('setCurrentUser', {
              email: user.email,
              displayName: user.displayName,
              photoURL: user.photoURL,
              uid: user.uid
            })
            await dispatch('fetchUserRole', user.email)
          } else {
            commit('setCurrentUser', null)
            commit('setUserRole', null)
          }
          commit('setAuthInitialized', true)
          resolve()
        })
      })
    },
    async fetchUserRole({ commit }, email) {
      try {
        const userDoc = await db.collection('users').doc(email).get()
        if (userDoc.exists) {
          const role = userDoc.data().role
          commit('setUserRole', role || 'user')
        } else {
          // Create user document with default role
          await db.collection('users').doc(email).set({
            email: email,
            role: 'user',
            createdAt: new Date().toISOString()
          })
          commit('setUserRole', 'user')
        }
      } catch (error) {
        console.error('Error fetching user role:', error)
        commit('setUserRole', null)
      }
    },
    async signInWithGoogle() {
      try {
        const provider = new firebase.auth.GoogleAuthProvider()
        await auth.signInWithPopup(provider)
        // Auth state listener will handle the rest
      } catch (error) {
        console.error('Google sign-in error:', error)
        throw error
      }
    },
    async signOut({ commit }) {
      try {
        await auth.signOut()
        commit('setCurrentUser', null)
        commit('setUserRole', null)
      } catch (error) {
        console.error('Sign out error:', error)
      }
    }
  },
  getters: {
    currentUser: state => state.currentUser,
    userRole: state => state.userRole,
    hasPrivilege: state => state.userRole === 'admin',
    authInitialized: state => state.authInitialized,
    isAuthenticated: state => state.currentUser !== null
  }
}
export default userAccess